import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { AttentionModalComponent } from '../../attention-modal/attention-modal.component';

type AttentionTypes = 'sameDayACHLimit' | 'sameDayWindowClosed';

@Component({
  selector: 'app-move-money-attention-modal',
  templateUrl: './move-money-attention-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RktButtonDirective, AttentionModalComponent],
})
export class MoveMoneyAttentionModalComponent {
  attentionType!: AttentionTypes;

  constructor(public activeModal: ActiveModal) {}
}
